export default class Confirm
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Confirm.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.message = this.DOM.$el.dataset[this.options.dataAttrMessage]
        this.DOM.$el.addEventListener('click', this.onClick.bind(this))
    }

    onClick(e) {
        if (this.message) {
            if (!confirm(this.message)) {
                e.preventDefault()
            }
        }
    }
}

Confirm.prototype.defaults = {
    dataAttrMessage: 'confirm',
}